import React from 'react';
import api from '../../../services/api';
import { useEffect, useState } from 'react'
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import '@fontsource/roboto/400.css';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import PublicIcon from '@mui/icons-material/Public';
import { Table, TableHead, TableRow, TableBody, TextField, Paper, Button, Grid, TablePagination, Typography, FormControlLabel } from '@mui/material';
import TableContainer from '@mui/material/TableContainer';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import CloseIcon from '@mui/icons-material/Close';
import NavBar_Top from '../../NavBar_Top/NavBar_Top';
import Rodape from '../../Rodape/Rodape';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
//import MotoIcon from '@mui/icons-material/TwoWheeler';
//import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import SearchIcon from '@mui/icons-material/Search';
import FilterltIcon from '@mui/icons-material/FilterAlt';
import '@fontsource/roboto/400.css';
import { alpha } from '@mui/material/styles';
import { pink } from '@mui/material/colors';
import Switch from '@mui/material/Switch';
import { DesktopDateTimePicker } from '@mui/x-date-pickers/DesktopDateTimePicker';
import L from 'leaflet';
//import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import { MapContainer, TileLayer, Polyline, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import ImagemSemDados from '../../../assets/img/sem_dados.jpg';
import ImagemMotoboy from '../../../assets/img/motoboy_nafil.jpg';
//import ImagemMotoboy2 from '../../../assets/img/motoboy_nafil2.jpg';
import Menu_Navegacao from './Menu_Navegacao';

const PinkSwitch = styled(Switch)(({ theme }) => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
        color: pink[600],
        '&:hover': {
            backgroundColor: alpha(pink[600], theme.palette.action.hoverOpacity),
        },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
        backgroundColor: pink[600],
    },
}));

const label = { inputProps: { 'aria-label': 'Color switch demo' } };

const Painel = () => {

    delete L.Icon.Default.prototype._getIconUrl;
    L.Icon.Default.mergeOptions({
        iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
        iconUrl: require('leaflet/dist/images/marker-icon.png'),
        shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
    });

    const [lista, setLista] = useState(null);
    const [analise, setAnalise] = useState(null);
    const [date, setDate] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [coordinates, setCoordinates] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [erroNormalDataInicial, setErroNormalDataInicial] = useState(false);
    const [erroNormalDataFinal, setErroNormalDataFinal] = useState(false);

    const [normalFilial, setNormalFilial] = useState(null);
    const [normalMotoboy, setNormalMotoboy] = useState(null);
    const [normalPreVenda, setNormalPreVenda] = useState(null);
    const [normalDataInicial, setNormalDataInicial] = useState(null);
    const [normalDataFinal, setNormalDataFinal] = useState(null);
    const [roteiroDataHoraIncial, setRoteiroDataHoraInicial] = useState(null);
    const [roteiroDataHoraFinal, setRoteiroDataHoraFinal] = useState(null);
    const [controleDados, setControleDados] = useState(false);
    const [openModalRoteiro, setOpenModalRoteiro] = useState(false);

    const locale = 'pt-br';

    const erroRetornoFalse = () => toast.error("Busca Incorreta no servidor",
        { position: toast.POSITION.TOP_CENTER, theme: "colored" });

    const handleDataInicial = (event) => {
        let data = event
        if (data && dayjs(data).isValid()) {
            setErroNormalDataInicial(false)
            console.log('valor da data Final', data)
            setNormalDataInicial(data)
        }
        else {
            setErroNormalDataInicial(true)
        }
    }

    const closeModal = () => setIsModalOpen(false);

    const handleDataFinal = (event) => {

        let data = event

        if (data && dayjs(data).isValid()) {
            setErroNormalDataFinal(false);
            setNormalDataFinal(data);
            setRoteiroDataHoraInicial(false)
        }
        else {
            setErroNormalDataFinal(true)
        }
    }


    const LimpaCamposData = () => {
        setNormalDataInicial(null)
        setNormalDataFinal(null)
        setNormalFilial('')
        setNormalMotoboy('')
        setNormalPreVenda('')
        setRoteiroDataHoraInicial(null)
        setRoteiroDataHoraFinal(null)
    }


    const BuscarInformacoesFiltro = () => {

        setControleDados(false)
        const dados = {
            "filial": normalFilial != '' ? normalFilial : null,
            "motoboy": normalMotoboy != '' ? normalMotoboy : null,
            "prevenda": normalPreVenda != '' ? normalPreVenda : null,
            "data_inicial": normalDataInicial,
            "data_final": normalDataFinal
        }

        api.post('AppEntregas/Logistica/Painel', dados).then((res) => {

            if (res.data == false) {
                setControleDados(true)
                LimpaCamposData()
            }
            else {
                setLista(res.data)
                setControleDados(false)
                LimpaCamposData()
            }

        }).catch((error) => {
            setControleDados(true)
            console.log('Excepction ao buscar os dados ', error)
        });
    }

    const openModal = (latitude, longitude) => {
        if (latitude === 'null' || longitude === 'null') {
            ErroCoordenadas()
            return;
        }

        if (latitude.length !== 0 && longitude.length !== 0) {
            console.log('Eu não sou nulo ')
            setCoordinates([latitude, longitude])
            setIsModalOpen(true);
            return
        }
        return
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const ErroCoordenadas = () => {
        toast.error("Sem Coordenadas !", {
            position: "bottom-center",
            theme: "colored"
        });
    }
    const ModalMapa = ({ open, onClose, coordinates }) => {
        return (
            <Modal
                open={open}
                onClose={onClose}
                aria-labelledby="map-modal-title"
                aria-describedby="map-modal-description"
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '80%',
                        height: '80%',
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: 4,
                    }}
                >
                    <MapContainer
                        center={coordinates}
                        zoom={13}
                        style={{ width: '100%', height: '100%' }}
                    >
                        <TileLayer
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        />
                        <Marker position={coordinates}></Marker>
                    </MapContainer>
                    <Button startIcon={<CloseIcon />} color='success' onClick={onClose} variant="contained" size='small' >Fechar</Button>
                </Box>
            </Modal>
        );
    }

    const handleModalRoteiro = () => { setOpenModalRoteiro(false) }

    // const MapaRoteiro = () => {

    //     // const route = [
    //     //     [37.7749, -122.4194], // São Francisco
    //     //     [34.0522, -118.2437], // Los Angeles
    //     //     [36.1699, -115.1398], // Las Vegas
    //     //     [40.7128, -74.0060],  // Nova York
    //     // ];

    //     const waypoints = [
    //         [37.7749, -122.4194], // São Francisco
    //         [36.7783, -119.4179], // Fresno
    //         [35.3733, -119.0187], // Bakersfield
    //         [34.0522, -118.2437], // Los Angeles
    //         [33.7701, -118.1937], // Long Beach
    //         [32.7157, -117.1611], // San Diego
    //         //[-22.4998201, -44.1074057],//Nafil
    //         //[-22.4999254, -44.0652421],//Mirante do Bosque
    //     ];

    //     const [routeCoordinates, setRouteCoordinates] = useState([]); // Coordenadas da rota

    //     //const start = [37.7749, -122.4194]; // São Francisco
    //     //const end = [34.0522, -118.2437]; // Los Angeles

    //     //const start = [-22.4999254, -44.0652421]; //mirante do bisque
    //     //const end = [-22.4998201, -44.1074057] //nafil

    //     useEffect(() => {
    //         // Função para obter a rota da API OSRM
    //         const fetchRoute = async () => {
    //             // Constrói a string com as coordenadas no formato requerido pela API
    //             const coordinatesString = waypoints
    //                 .map(point => `${point[1]},${point[0]}`) // Formata como longitude,latitude
    //                 .join(';'); // Junta os pontos com ";"

    //             const url = `https://router.project-osrm.org/route/v1/driving/${coordinatesString}?overview=full&geometries=geojson`;

    //             try {
    //                 const response = await fetch(url);
    //                 const data = await response.json();
    //                 if (data.routes && data.routes.length > 0) {
    //                     // Extraí as coordenadas da rota
    //                     const coordinates = data.routes[0].geometry.coordinates.map(coord => [coord[1], coord[0]]);
    //                     setRouteCoordinates(coordinates);
    //                 }
    //             } catch (error) {
    //                 console.error('Erro ao obter a rota:', error);
    //             }
    //         };

    //         fetchRoute();
    //     }, [waypoints]);




    //     return (
    //         <>
    //             <MapContainer
    //                 center={waypoints[0]} // Centraliza no primeiro ponto
    //                 zoom={6} // Define o nível de zoom
    //                 style={{ height: '500px', width: '100%' }}
    //             >
    //                 {/* Camada base do mapa */}
    //                 <TileLayer
    //                     url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    //                     attribution="&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors"
    //                 />
    //                 {/* Adiciona a rota no mapa */}
    //                 {routeCoordinates.length > 0 && <Polyline positions={routeCoordinates} color="green" />}
    //                 {/* Marcadores para os waypoints */}
    //                 {waypoints.map((point, index) => (
    //                     <Marker key={index} position={point} />
    //                 ))}
    //             </MapContainer>

    //             {/* <MapContainer
    //                 center={start}
    //                 zoom={16}
    //                 style={{ height: '450px', width: '100%' }}
    //             >
    //                 <TileLayer
    //                     url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    //                     attribution="&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors"
    //                 />

    //                 {routeCoordinates.length > 0 && <Polyline positions={routeCoordinates} color="blue" />}
    //                 <Marker position={start} />
    //                 <Marker position={end} />
    //             </MapContainer> */}
    //         </>
    //     );
    // }

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: 'green',
            color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 12,
        },
    }));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
        '&:last-child td, &:last-child th': {
            border: 0,
        },
    }));

    const getRastreadores = async () => {
        setLista(null)
        api.get('AppEntregas/ConsultaRastrear').then((response) => {
            const sortedData = response.data.sort((a, b) => b.ids_rastrear - a.ids_rastrear);
            setLista(sortedData)
        }).catch((erro) => {
            console.log('Erro ao buscar rastreadores ', erro)
        })
    }


    const ControleHorarioComercial = () => {

        const now = new Date();
        const day = now.getDay();
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const time = `${hours}:${minutes}`;
        setDate(time)
        const currentTime = now.getHours() * 60 + now.getMinutes();
        const horarios = {
            'entrada': '08:30',
            'saida_almoco': '12:00',
            'retorno_almoco': '13:00',
            'final_semana': '17:30',
            'entrada_sabado': '08:00',
            'saida_sabado': '12:00'
        }

        const HoraParaMinutos = (timeString) => {
            const [hours, minutes] = timeString.split(':').map(Number);
            return hours * 60 + minutes;
        };

        if (day >= 1 && day <= 5) {
            const startTime = HoraParaMinutos(horarios.entrada);
            const lunchStart = HoraParaMinutos(horarios.saida_almoco);
            const lunchEnd = HoraParaMinutos(horarios.retorno_almoco);
            const endTime = HoraParaMinutos(horarios.final_semana);

            return (currentTime >= startTime && currentTime < lunchStart) ||
                (currentTime >= lunchEnd && currentTime < endTime);
        }
        else if (day === 6) {
            const startTimeSabado = HoraParaMinutos(horarios.entrada_sabado);
            const endTimeSabado = HoraParaMinutos(horarios.saida_sabado);
            return currentTime >= startTimeSabado && currentTime < endTimeSabado;
        }

        return false;
    }

    useEffect(() => {
        const now = new Date();
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const time = `${hours}:${minutes}`;
        setDate(time)
        getRastreadores();
    }, [])


    useEffect(() => {

    }, [])


    useEffect(() => {

        const executeTime = () => {
            let myTime = ControleHorarioComercial();
            setAnalise(myTime)
        }

        executeTime()

        //colocando atualização de tempos em tempos 

        // const intervaloTempo = setInterval(executeTime, 10000);
        // return () => clearInterval(intervaloTempo);

    }, [lista])

    function formatDate(isoString) {
        const date = new Date(isoString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${day}/${month}/${year} às ${hours}:${minutes}`;
    }

    const tipoRastrear = (valor) => {
        switch (valor) {
            case 1:
                return 'Login';
            case 2:
                return 'Entregue';
            case 3:
                return 'Pagamento';
            case 4:
                return 'Periódico';
            case 5:
                return 'B Lote';
            default:
                return 'Error';
        }
    }

    const FilterNormal = () => {
        return (
            <Grid container spacing={3} >
                <Grid item xs={4}>
                    <TextField id="filial" onChange={(e) => setNormalFilial(e.target.value)} label="Filial" value={normalFilial} fullWidth type='number' variant="outlined" />
                </Grid>
                <Grid item xs={4}>
                    <TextField id="motoboy" onChange={(e) => setNormalMotoboy(e.target.value)} label="Motoboy" value={normalMotoboy} fullWidth type='number' variant="outlined" />
                </Grid>
                <Grid item xs={4}>
                    <TextField id="prevenda" onChange={(e) => setNormalPreVenda(e.target.value)} label="Pré Venda" value={normalPreVenda} fullWidth type='number' variant="outlined" />
                </Grid>
                <Grid item xs={4}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
                        <DesktopDatePicker
                            fullWidth
                            label="Data Inicial"
                            value={normalDataInicial}
                            error={erroNormalDataInicial}
                            onChange={handleDataInicial}
                            renderInput={(params) => <TextField {...params} fullWidth />}
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={4}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
                        <DesktopDatePicker
                            fullWidth
                            label="Data Final"
                            value={normalDataFinal}
                            erro={erroNormalDataFinal}
                            onChange={handleDataFinal}
                            renderInput={(params) => <TextField {...params} fullWidth />}
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={4}>
                    <Button size={'large'} onClick={() => BuscarInformacoesFiltro()} fullWidth startIcon={<SearchIcon />} color='success' variant="contained">Filtrar</Button>
                </Grid>
            </Grid>
        );
    }



    const renderPage = () => {
        return (
            <>
                <Grid container spacing={3} justifyContent={'center'}>
                    <Box sx={{ width: '1200px' }}>
                        <br />
                        <br />
                        {FilterNormal()}
                    </Box>
                    <Grid item xs={12} >
                        <Box sx={{ width: '1200px', mx: 'auto' }}>
                            {
                                !controleDados
                                    ?
                                    <TableContainer component={Paper}>
                                        <Table aria-label="customized table">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell align="center">Id</StyledTableCell>
                                                    <StyledTableCell align="center">Loja</StyledTableCell>
                                                    <StyledTableCell align="center">Moto</StyledTableCell>
                                                    <StyledTableCell align="center">Data</StyledTableCell>
                                                    <StyledTableCell align="center">Tipo</StyledTableCell>
                                                    <StyledTableCell align="center">Id Venda</StyledTableCell>
                                                    <StyledTableCell align="center">Id VL</StyledTableCell>
                                                    <StyledTableCell align="center">Latitude</StyledTableCell>
                                                    <StyledTableCell align="center">Longitude</StyledTableCell>
                                                    <StyledTableCell align="center">Mapa</StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    lista
                                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                        .map((row) => (
                                                            <StyledTableRow key={row.ids_rastrear}>
                                                                <StyledTableCell align="center">{row.ids_rastrear}</StyledTableCell>
                                                                <StyledTableCell align="center">{row.ids_rastrear_loja}</StyledTableCell>
                                                                <StyledTableCell align="center">{row.moto}</StyledTableCell>
                                                                <StyledTableCell align="center">{formatDate(row.data)}</StyledTableCell>
                                                                <StyledTableCell align="center">{tipoRastrear(row.tipo)}</StyledTableCell>
                                                                <StyledTableCell align="center">{row.venda_id}</StyledTableCell>
                                                                <StyledTableCell align="center">{row.venda_id_loja}</StyledTableCell>
                                                                <StyledTableCell align="center">{row.latitude}</StyledTableCell>
                                                                <StyledTableCell align="center">{row.longitude}</StyledTableCell>
                                                                <StyledTableCell align="center">
                                                                    <Button color='success' onClick={() => openModal(row.latitude, row.longitude)} variant="contained" startIcon={<PublicIcon />}>Ver no Mapa</Button>
                                                                </StyledTableCell>
                                                            </StyledTableRow>
                                                        ))}
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            rowsPerPageOptions={[5, 10, 25, 50]}
                                            component="div"
                                            count={lista.length}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            onPageChange={handleChangePage}
                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                        />
                                    </TableContainer>
                                    :
                                    <img src={ImagemSemDados} alt='Sem dados para exibir ' />
                            }
                        </Box>
                    </Grid>
                </Grid >
                <ModalMapa open={isModalOpen} onClose={closeModal} coordinates={coordinates} />
                <br />
                <Rodape />
                <ToastContainer />
            </>
        );
    }

    const load = () => {
        return (
            <Grid
                container
                justifyContent="center"
                alignItems="center"
                sx={{
                    height: '100vh' // Preenche toda a altura da tela 
                }}
            >
                <Stack spacing={2} direction="row">
                    <CircularProgress color="success" />
                </Stack>
            </Grid>
        );
    }

    return (
        <>
            <NavBar_Top />
            <br />
            <Menu_Navegacao />
            <br />
            <br />
            {
                lista == null
                    ?
                    load()
                    :
                    renderPage()
            }
            <ToastContainer />
        </>
    );
}

export default Painel;